'use es6';

import AutomationPlatformFlow from './objectDefinitions/AutomationPlatformFlow';
import Campaign from './objectDefinitions/Campaign';
import Call from './objectDefinitions/Call';
import CommercePayment from './objectDefinitions/CommercePayment';
import Conversation from './objectDefinitions/Conversation';
import ConversationSession from './objectDefinitions/ConversationSession';
import DataPrivacyRequest from './objectDefinitions/DataPrivacyRequest';
import Email from './objectDefinitions/Email';
import FeedbackSubmission from './objectDefinitions/FeedbackSubmission';
import FeedbackSurvey from './objectDefinitions/FeedbackSurvey';
import Forms from './objectDefinitions/Forms';
import Invoice from './objectDefinitions/Invoice';
import MarketingEmail from './objectDefinitions/MarketingEmail';
import MarketingSms from './objectDefinitions/MarketingSms';
import MeetingEvent from './objectDefinitions/MeetingEvent';
import Note from './objectDefinitions/Note';
import PartnerAccount from './objectDefinitions/PartnerAccount';
import Lead from './objectDefinitions/Lead';
import PublishingTask from './objectDefinitions/PublishingTask';
import Sequence from './objectDefinitions/Sequence';
import SequenceEnrollment from './objectDefinitions/SequenceEnrollment';
import Subscription from './objectDefinitions/Subscription';
import Task from './objectDefinitions/Task';
import ObjectLists from './objectDefinitions/ObjectLists';
import Order from './objectDefinitions/Order';
import Cart from './objectDefinitions/Cart';
import Communication from './objectDefinitions/Communication';
import PostalMail from './objectDefinitions/PostalMail';
import GoalTarget from './objectDefinitions/GoalTarget';
import User from './objectDefinitions/User';
import PartnerClient from './objectDefinitions/PartnerClient';
import PaymentLink from './objectDefinitions/PaymentLink';
import DealRegistration from './objectDefinitions/DealRegistration';
import Service from './objectDefinitions/Service';
import PartnerService from './objectDefinitions/PartnerService';
import Appointment from './objectDefinitions/Appointment';
import Course from './objectDefinitions/Course';
import Listing from './objectDefinitions/Listing';
import CustomerSuccessAlert from './objectDefinitions/CustomerSuccessAlert';
const ObjectDefinitions = [Appointment, AutomationPlatformFlow, Campaign, Call, Cart, CommercePayment, Communication, Conversation, ConversationSession, Course, CustomerSuccessAlert, DataPrivacyRequest, DealRegistration, Email, FeedbackSubmission, Forms, FeedbackSurvey, GoalTarget, Invoice, Lead, Listing, MarketingEmail, MarketingSms, MeetingEvent, Note, ObjectLists, Order, PartnerAccount, PartnerClient, PartnerService, PaymentLink, PublishingTask, PostalMail, Sequence, SequenceEnrollment, Service, Subscription, Task, User];
const getObjectDefinitions = () => ObjectDefinitions;
export default getObjectDefinitions;